module.exports = __webpack_public_path__ + "static/img/yinpin.ae28130.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yinpin.png
// module id = mDd0
// module chunks = 1